export const E_RESERVE = 'DM';
export const BUY_NOW = 'FP';
export const MAKE_OFFER = 'MO';
export const FEATURED = 'FA';
export const RBA_LIVE = 'LIVE';
export const SELLER_BID_SELECT = 'SBS';
export const SEALED_BID_UNRESERVED = 'SBU';
export const SEALED_BID_SELLER_BID_SELECT = 'SBSBS';
export const UNKNOWN = 'Unknown';
export const INVENTORY_CONTROL = 'IC';

export interface SaleTypeOption {
  code: string;
  name: string;
}
export enum assetSaleTypeName {
  DM = 'Reserve Auction',
  FP = 'Buy Now',
  MO = 'Make Offer',
  FA = 'Featured Online',
  LIVE = 'RBA Live',
  IC = 'Inventory Control / Holding Pen',
  SBS = 'Seller Bid Select',
  SBU = 'Sealed Bid Unreserved',
  SBSBS = 'Sealed Bid Seller Bid Select'
}
export const ironPlanetSaleTypeOptions: SaleTypeOption[] = [
  {
    code: FEATURED,
    name: assetSaleTypeName[FEATURED]
  },
  {
    code: BUY_NOW,
    name: assetSaleTypeName[BUY_NOW]
  },
  {
    code: MAKE_OFFER,
    name: assetSaleTypeName[MAKE_OFFER]
  },
  {
    code: E_RESERVE,
    name: assetSaleTypeName[E_RESERVE]
  },
  {
    code: SELLER_BID_SELECT,
    name: assetSaleTypeName[SELLER_BID_SELECT]
  },
  {
    code: SEALED_BID_UNRESERVED,
    name: assetSaleTypeName[SEALED_BID_UNRESERVED]
  },
  {
    code: SEALED_BID_SELLER_BID_SELECT,
    name: assetSaleTypeName[SEALED_BID_SELLER_BID_SELECT]
  }
];

export const multiChannelSaleTypeOptions: SaleTypeOption[] = [
  {
    code: FEATURED,
    name: assetSaleTypeName[FEATURED]
  },
  {
    code: RBA_LIVE,
    name: assetSaleTypeName[RBA_LIVE]
  },
  {
    code: BUY_NOW,
    name: assetSaleTypeName[BUY_NOW]
  },
  {
    code: MAKE_OFFER,
    name: assetSaleTypeName[MAKE_OFFER]
  },
  {
    code: E_RESERVE,
    name: assetSaleTypeName[E_RESERVE]
  },
  {
    code: SELLER_BID_SELECT,
    name: assetSaleTypeName[SELLER_BID_SELECT]
  },
  {
    code: SEALED_BID_UNRESERVED,
    name: assetSaleTypeName[SEALED_BID_UNRESERVED]
  },
  {
    code: SEALED_BID_SELLER_BID_SELECT,
    name: assetSaleTypeName[SEALED_BID_SELLER_BID_SELECT]
  }
];

export const rbSaleTypeOptions: SaleTypeOption[] = [
  {
    code: RBA_LIVE,
    name: assetSaleTypeName[RBA_LIVE]
  }
];

export const consigmentSaleTypeOptions: SaleTypeOption[] = [
  {
    code: RBA_LIVE,
    name: assetSaleTypeName[RBA_LIVE]
  },
  {
    code: FEATURED,
    name: assetSaleTypeName[FEATURED]
  },
  {
    code: BUY_NOW,
    name: assetSaleTypeName[BUY_NOW]
  },
  {
    code: MAKE_OFFER,
    name: assetSaleTypeName[MAKE_OFFER]
  },
  {
    code: E_RESERVE,
    name: assetSaleTypeName[E_RESERVE]
  },
  {
    code: SELLER_BID_SELECT,
    name: assetSaleTypeName[SELLER_BID_SELECT]
  },
  {
    code: SEALED_BID_UNRESERVED,
    name: assetSaleTypeName[SEALED_BID_UNRESERVED]
  },
  {
    code: SEALED_BID_SELLER_BID_SELECT,
    name: assetSaleTypeName[SEALED_BID_SELLER_BID_SELECT]
  }
];

export const consignmentLiveSaleTypeOptions: SaleTypeOption[] = rbSaleTypeOptions;

export const consignmentOnLineSaleTypeOptions: SaleTypeOption[] = ironPlanetSaleTypeOptions;


export class AssetSaleType {
  public static isChannelChanged(sourceSaleType: string, targetSaleType: string): boolean {
    if (!sourceSaleType || !targetSaleType) {
      return false;
    } else if (sourceSaleType === RBA_LIVE && targetSaleType !== RBA_LIVE) {
      return false;
    } else if (sourceSaleType !== RBA_LIVE && targetSaleType === RBA_LIVE) {
      return false;
    } else {
      return true;
    }
  }
}
